<div class="rounded-4xl shadow-lg/30 w-full flex overflow-hidden">
  <div class="bg-(--color-card-bg-header) w-5"></div>

  <div class="flex flex-col gap-2 p-3 w-[calc(100%-1.25rem)]">
    <div class="flex justify-between w-full">
      <div class="flex items-center gap-2 text-(--color-card-header)!">
        <mat-icon class="text(--color-card-header-icon)!">article</mat-icon>

        <div class="font-semibold">{{ ticketSection?.title }} {{ ticketSection?.id }}</div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <div class="grid gap-2 grid-cols-2">
        @for (data of ticketSection?.data; track data) {
          <div class="flex flex-col gap-2 text-sm">
            <div class="text-(--color-text-secondary) font-medium">{{ data.description }}</div>
            <div class="text-(--color-text-primary) font-medium">
              {{ data.value }}
            </div>
          </div>
        }
      </div>

      @if (ticketSection?.textButton) {
        <div class="flex justify-center gap-4 px-2">
          <button
            class="button-general-border px-2! w-[50%]"
            matButton
            (click)="onDetail()"
            type="submit"
          >
            {{ ticketSection?.textButton }}
          </button>

          <!-- <button matMiniFab class="px-2 text-lg bg-transparent!" (click)="onDelete()">
              <mat-icon class="text-(--color-card-icon-delete)!">delete</mat-icon>
            </button> -->
        </div>
      }
    </div>
  </div>
</div>
